// src/utils/navigationBarManager.js
import { Capacitor } from '@capacitor/core';

let StatusBar = null;

const loadStatusBar = async () => {
  if (StatusBar) return StatusBar;
  try {
    const mod = await import(/* webpackIgnore: true */ '@capacitor/status-bar');
    StatusBar = mod.StatusBar;
    return StatusBar;
  } catch (e) {
    console.warn('StatusBar plugin not available:', e);
    return null;
  }
};

export class NavigationBarManager {
  static async initialize() {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not a native platform, skipping navigation bar management');
      return;
    }

    try {
      const sb = await loadStatusBar();
      if (!sb) {
        console.log('StatusBar plugin not available');
        return;
      }

      await sb.setOverlaysWebView({ overlay: false });
      await sb.setStyle({ style: 'DARK' });
      await sb.setBackgroundColor({ color: '#B8860B' });

      console.log('Navigation bar initialized successfully');
    } catch (error) {
      console.error('Error initializing navigation bar:', error);
    }
  }

  static async enableFullScreen() {
    if (!Capacitor.isNativePlatform()) return;

    try {
      const sb = await loadStatusBar();
      if (!sb) return;

      await sb.setOverlaysWebView({ overlay: false });
      await sb.setStyle({ style: 'DARK' });
      await sb.setBackgroundColor({ color: '#B8860B' });

      console.log('Full screen enabled');
    } catch (error) {
      console.error('Failed to enable full screen:', error);
    }
  }

  static async showStatusBar() {
    if (!Capacitor.isNativePlatform()) return;

    try {
      const sb = await loadStatusBar();
      if (!sb) return;

      await sb.setOverlaysWebView({ overlay: false });
      await sb.show();
      await sb.setOverlaysWebView({ overlay: false });
      await sb.setStyle({ style: 'DARK' });
      await sb.setBackgroundColor({ color: '#B8860B' });
      console.log('Status bar shown');
    } catch (error) {
      console.error('Failed to show status bar:', error);
    }
  }

  static async setBackgroundColor(color) {
    if (!Capacitor.isNativePlatform()) return;

    try {
      const sb = await loadStatusBar();
      if (!sb) return;

      await sb.setBackgroundColor({ color });
      console.log('Status bar color set to:', color);
    } catch (error) {
      console.error('Failed to set status bar color:', error);
    }
  }
}
